(function() { window.GUID_6c719183_0644_46a0_90af_2f972066708d = { getGuid: function() { return "6c719183-0644-46a0-90af-2f972066708d"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PremiumLockedOverlayCallToActionVariant;
        (function (PremiumLockedOverlayCallToActionVariant) {
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["Button"] = 0] = "Button";
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["Badge_Centered"] = 1] = "Badge_Centered";
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["Badge_Bottom"] = 2] = "Badge_Bottom";
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["None"] = 3] = "None";
        })(PremiumLockedOverlayCallToActionVariant = Enumeration.PremiumLockedOverlayCallToActionVariant || (Enumeration.PremiumLockedOverlayCallToActionVariant = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PremiumLockedOverlayCallToActionVariant.pre.js.map
